import Layout from "@/views/Backend/Admin/Layout"

const adminRouter = {
  path: "/admin/:appId",
  component: Layout,
  name: "Admin",
  redirect: "/admin/:projectId/app/info",
  children: [
    {
      path: "app/info",
      component: () => import("@/views/Backend/Admin/App/Info"),
      name: "admin-app-info",
      meta: { hideNav: true }
    },
    {
      path: "app/operation",
      component: () => import("@/views/Backend/Admin/App/Operation"),
      name: "admin-app-operation",
      meta: { hideNav: true }
    },
    {
      path: "app/groupRobot",
      component: () => import("@/views/Backend/Admin/App/Robot"),
      name: "admin-app-robot",
      meta: { hideNav: true }
    },
    {
      path: "sheet",
      component: () => import("@/views/Backend/Admin/Sheet"),
      name: "admin-sheet",
      meta: { hideNav: true }
    },
    {
      path: "workflow",
      component: () => import("@/views/Backend/Admin/Workflow"),
      name: "admin-workflow",
      meta: { hideNav: true }
    },
    {
      path: "sync-rule-master",
      component: () => import("@/views/Backend/Admin/Connect/SyncRuleMaster"),
      name: "admin-sync-rule-master",
      meta: { hideNav: true }
    },
    {
      path: "sync-rule-slave",
      component: () => import("@/views/Backend/Admin/Connect/SyncRuleSlave"),
      name: "admin-sync-rule-slave",
      meta: { hideNav: true }
    },
    {
      path: "sync-log",
      component: () => import("@/views/Backend/Admin/Connect/SyncLog"),
      name: "admin-sync-log",
      meta: { hideNav: true }
    },
    {
      path: "display/menu",
      component: () => import("@/views/Backend/Admin/Display/Menu"),
      name: "admin-menu-display",
      meta: { hideNav: true }
    },
    {
      path: "template/print",
      component: () => import("@/views/Backend/Admin/Template/print"),
      name: "admin-print-template",
      meta: { hideNav: true }
    },
    {
      path: "template/export",
      component: () => import("@/views/Backend/Admin/Template/export"),
      name: "admin-export-template",
      meta: { hideNav: true }
    },
    {
      path: "statistics/board",
      component: () => import("@/views/Backend/Admin/Statistics"),
      name: "admin-statistics-board",
      meta: { hideNav: true }
    },
    {
      path: "statistics/count",
      component: () => import("@/views/Backend/Admin/Statistics/AutoCount"),
      name: "admin-statistics-auto-count",
      meta: { hideNav: true }
    },
    {
      path: "data/recycle",
      component: () => import("@/views/Backend/Admin/Data/Recycle"),
      name: "admin-data-recycle",
      meta: { hideNav: true }
    },
    {
      path: "role",
      component: () => import("@/views/Backend/Admin/Role"),
      name: "admin-role",
      meta: { hideNav: true }
    },
    {
      path: "member",
      component: () => import("@/views/Backend/Admin/Member"),
      name: "admin-member",
      meta: { hideNav: true }
    }
  ]
}

export default adminRouter
